/**
 * Resolve post-login redirect from ?redirect= and ?intent= query params.
 * Only allows same-origin relative paths.
 */
import { getIntentFromSearch, getRedirectForIntent } from './signupIntent';

export const getSafeAuthRedirect = (search) => {
  const redirect = new URLSearchParams(search).get('redirect');
  if (redirect && redirect.startsWith('/') && !redirect.startsWith('//')) {
    return redirect;
  }
  return '/dashboard';
};

/**
 * Resolve post-auth destination: explicit ?redirect= wins, else ?intent= mapping, else dashboard.
 */
export const resolvePostAuthRedirect = (search) => {
  const params = new URLSearchParams(search);
  const explicitRedirect = params.get('redirect');
  if (explicitRedirect && explicitRedirect.startsWith('/') && !explicitRedirect.startsWith('//')) {
    return explicitRedirect;
  }
  const intent = getIntentFromSearch(search);
  if (intent) {
    return getRedirectForIntent(intent);
  }
  return '/dashboard';
};

/**
 * When an authenticated user visits signup with intent, route them to the target flow.
 */
export const resolveAuthenticatedSignupRedirect = (search, user) => {
  const intent = getIntentFromSearch(search);
  if (intent === 'interviewer' && user && !user.is_interviewer) {
    return '/marketplace/apply';
  }
  if (intent === 'recruiter') {
    return '/hiring';
  }
  if (intent === 'candidate' || !intent) {
    return '/dashboard';
  }
  return resolvePostAuthRedirect(search);
};
